import { useElements, useStripe } from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getContentPlacesApis } from "../apis/ContentApis";
import { PaymentCreateIntentApi } from "../apis/PaymentApis";
import {
  addPlacesApis,
  editPlaceDetailsApis
} from "../apis/PlacesApis";
import {
  uploadMultipleFileImage,
  uploadSingleFileImage,
  uploadSingleFileVideo,
} from "../apis/UploadImgApis";
import { setAllDealsData, setAllPlacesData } from "../redux/action";
export const usePlaceHooks = (state) => {
  //Add new places states and functionalties
  //all redux
  const dispatch = useDispatch();
  //stripe functionalites
  const stripe = useStripe();
  const element = useElements();
  const [stripeModalOpen, setStripeModalOpen] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  //all local states
  const [thankYouModalOpen, setThankYouModalOpen] = useState(false);
  const [addPhotosImages, setAddPhotosImages] = useState([]);
  const [addVideosImages, setAddVideosImages] = useState([]);
  const [addMenuImages, setAddMenuImages] = useState(null);
  const [placeData, setPlaceData] = useState({
    name: "",
    types: [],
    categories: [],
    genderPreference: [],
    description: "",
    availability: [],
    location: {},
    geo: {},
    offers: [],
    reservationLink: "",
    companyName: "",
    billingAddress: {},
    menuImages: null,
    photos: [],
    videos: null,
  });
  const copyLocationDetailsToBilling = () => {
    setPlaceData({
      ...placeData,
      billingAddress: {
       ...placeData?.location
      }
    })
   toast.success("Location is copied....")
  }
  //all validations
  const isFormValid =
    placeData?.name?.trim() &&
    placeData?.types?.length > 0 &&
    placeData?.reservationLink?.trim() &&
    placeData?.availability &&
    placeData?.location &&
    placeData?.companyName?.trim() &&
    placeData?.billingAddress &&
    placeData?.genderPreference &&
    placeData?.categories?.length > 0 &&
    placeData?.description?.trim() &&
    placeData?.photos?.length > 0 &&
    placeData?.videos &&
    placeData?.menuImages;
  //all functions
  const onPressPlacesPayBtn = () => {

    let payload = {
      name: placeData?.name,
      types: placeData?.types,
      categories: placeData?.categories,
      genderPreference: [placeData?.genderPreference],
      description: placeData?.description,
      availability: placeData?.availability,
      location: {
        streetAddress: placeData?.location?.streetAdress?.address,
        city: placeData?.location?.citySelected,
        country: placeData?.location?.countrySelectedName,
        zipCode: placeData?.location?.zipCodeValue,
        stateProvince: placeData?.location?.stateSelected?.name ?? placeData?.location?.stateSelected,
        coordinates: { ...(placeData?.location?.coordinates ?? { lat: 0, lng: 0 }) }

      },
      geo: {
        type: "Point",
        coordinates: [
          parseFloat(placeData?.location?.coordinates?.lat),
          parseFloat(placeData?.location?.coordinates?.lng),
        ],
      },
      reservationLink: placeData?.reservationLink,
      companyName: placeData?.companyName,
      billingAddress: {
        streetAddress: placeData?.billingAddress?.streetAdress?.address,
        city: placeData?.billingAddress?.citySelected,
        country: placeData?.billingAddress?.countrySelectedName,
        zipCode: placeData?.billingAddress?.zipCodeValue,
        stateProvince: placeData?.location?.stateSelected?.name ?? placeData?.location?.stateSelected,
        coordinates: {
          lat: placeData?.billingAddress?.streetAdress?.lat,
          lng: placeData?.billingAddress?.streetAdress?.lng,
        },
      },
      photos: [placeData?.photos],
      menuImages: [placeData?.menuImages],
      videos: [placeData?.videos],
      offers: placeData?.offers,
    };





    const formData = new FormData();
    if (placeData?.photos?.length) {
      placeData.photos.forEach((photo) => {
        formData.append("files", photo); // append File directly
      });
    }
    uploadMultipleFileImage(formData).then((res) => {
      // payload.photos = res?.data?.files;
      let photoObj = res?.data?.files?.map((file) => file?.url);
      payload.photos = photoObj;
      let menuObj = {
        file: placeData?.menuImages,
      };
      uploadSingleFileImage(menuObj).then((res) => {
        payload.menuImages = res?.data;
        if (res?.success) {
          let videoObj = {
            "video-file": placeData?.videos,
          };
          uploadSingleFileVideo(videoObj).then((res) => {
            payload.videos = res?.data;
            console.log("payload in add places", payload);
            addPlacesApis(payload, (response) => {
              console.log("response in add places", response?.data);
              if (response?.success) {
                // setThankYouModalOpen(true);
                let paymentPayload = {
                  contentType: "place",
                  contentId: response?.data?.place?._id,
                  amount: 450,
                };
                PaymentCreateIntentApi(paymentPayload).then((res) => {
                  console.log("response of intent is ==> ", res);
                  if (res?.success) {
                    const { clientSecret, customer, ephemeralKey } = res?.data;
                    setClientSecret(clientSecret);
                    setStripeModalOpen(true);
                  }
                });
              }
            });
          });
        } else {
          toast.error(res?.error?.response?.data?.message);
        }
      });
    });
  };
  /// my places screen states and functionalities
  //all local states
  const [placesListData, setPlacesListData] = useState([]);
  //all useEffect and functions
  useEffect(() => {
    // Fetch places data or perform any initialization here
    getContentPlacesApis(true)
      .then((data) => {
        setPlacesListData(data?.places);
        dispatch(setAllPlacesData(data?.places));
        dispatch(setAllDealsData(data?.deals));
        // You can set the fetched data to a state if needed
        // setPlacesData(data);
      })
      .catch((error) => {
        console.error("Error fetching places data: ", error);
      });
  }, []);
  //all edit place screen states and functioality
  //all local states
  const [editPlaceData, setEditPlaceData] = useState(
    state
      ? state
      : {
        types: ["Choice-1"],
        availibility: [
          {
            title: "Mon",
            from: new Date().getTime(),
            to: new Date().getTime(),
            checked: true,
          },
        ],
        images: [],
        menu: null,
        video: null,
      }
  );

  //all useEffect
  useEffect(() => {

    setEditPlaceData(
      state
        ? state
        : {
          types: ["Choice-1"],
          availibility: [
            {
              title: "Mon",
              from: new Date().getTime(),
              to: new Date().getTime(),
              checked: true,
            },
          ],
          images: [],
          menu: null,
          video: null,
        }
    );
  }, [state]);


  //all  functions
  const onPressEditPayBtn = async() => {

    let payload = {
      _id: editPlaceData?._id,
      name: editPlaceData?.name,
      types: editPlaceData?.types,
      categories: editPlaceData?.categories,
      genderPreference: editPlaceData?.genderPreference,
      description: editPlaceData?.description,
      availability: editPlaceData?.availability,

      location: {
        streetAddress: editPlaceData?.location?.streetAdress?.address ?? editPlaceData?.location?.streetAdress
          ??editPlaceData?.billingAddress?.streetAddress,
        city: editPlaceData?.location?.citySelected ?? editPlaceData?.location?.city,
        country: editPlaceData?.location?.countrySelectedName ?? editPlaceData?.location?.country,
        zipCode: editPlaceData?.location?.zipCodeValue ?? editPlaceData?.location?.zipCode,
        stateProvince: editPlaceData?.location?.stateSelected?.name ?? placeData?.location?.stateSelected

          ?? editPlaceData?.location?.stateProvince,
        coordinates: { ...(editPlaceData?.location?.coordinates ?? { lat: 0, lng: 0 }) }

      },
      geo: {
        type: "Point",
        coordinates: [
          parseInt(editPlaceData?.location?.coordinates?.lng),
          parseInt(editPlaceData?.location?.coordinates?.lat),
        ],
      },
      reservationLink: editPlaceData?.reservationLink,
      companyName: editPlaceData?.companyName,
      billingAddress: {
        streetAddress: editPlaceData?.billingAddress?.streetAdress?.address ?? editPlaceData?.billingAddress?.streetAdress ??
          editPlaceData?.billingAddress?.streetAddress,
        city: editPlaceData?.billingAddress?.citySelected ?? editPlaceData?.billingAddress?.city,
        country: editPlaceData?.billingAddress?.countrySelectedName ?? editPlaceData?.billingAddress?.country,
        zipCode: editPlaceData?.billingAddress?.zipCodeValue ?? editPlaceData?.billingAddress?.zipCode,
        stateProvince: editPlaceData?.billingAddress?.stateSelected?.name ?? editPlaceData?.billingAddress?.stateSelected
          ?? editPlaceData?.billingAddress?.stateProvince,

      },
      photos: editPlaceData?.photos,
      menuImages: editPlaceData?.menuImages,
      videos: editPlaceData?.videos,
      offers: editPlaceData?.offers,
    };


    //add code
    try {
      const formData = new FormData();
    
      // Upload only new photo objects (not string URLs)
      const photoFiles = editPlaceData?.photos?.filter((p) => typeof p === "object") || [];
      const existingPhotoUrls = editPlaceData?.photos?.filter((p) => typeof p === "string") || [];
    
      photoFiles.forEach((photo) => {
        formData.append("files", photo);
      });
    
      // Upload images (if any new ones exist)
      let uploadedPhotos = [];
      if (photoFiles.length > 0) {
        const res = await uploadMultipleFileImage(formData);
        if (res?.success) {
          uploadedPhotos = res?.data?.files?.map((file) => file?.url ?? "") || [];
        } else {
          throw new Error(res?.error?.response?.data?.message || "Failed to upload photos");
        }
      }
    
      payload.photos = [...existingPhotoUrls, ...uploadedPhotos];
    
      // Handle menu image (single file in array)
      let menuUrl = editPlaceData?.menuImages?.[0];
      if (typeof menuUrl === "object") {
        const menuObj = { file: menuUrl };
        const res = await uploadSingleFileImage(menuObj);
        if (res?.success) {
          payload.menuImages = res?.data;
        } else {
          throw new Error(res?.error?.response?.data?.message || "Failed to upload menu image");
        }
      } else {
        payload.menuImages = menuUrl; // keep existing
      }
    
      // Handle video (single file in array)
      let videoUrl = editPlaceData?.videos?.[0];
      if (typeof videoUrl === "object") {
        const videoObj = { "video-file": videoUrl };
        const res = await uploadSingleFileVideo(videoObj);
        if (res?.success) {
          payload.videos = res?.data;
        } else {
          throw new Error(res?.error?.response?.data?.message || "Failed to upload video");
        }
      } else {
        payload.videos = videoUrl; // keep existing
      }
    
      console.log("payload in edit place", payload);
    
    } catch (error) {
      console.error("Error updating place:", error);
      toast?.error(error?.message || "Something went wrong during file uploads");
      return;
    }

  
    
    //add code

    
    editPlaceDetailsApis(payload?._id, payload).then((res) => {
      console.log("res", res)
      if (res?.success) {
        toast.success("Place Detail Added successfully");
      } else {
        toast.error(res?.error?.response?.data?.message);
      }
    });
  };
  return {
    placeData,
    setPlaceData,
    thankYouModalOpen,
    setThankYouModalOpen,
    stripeModalOpen,
    setStripeModalOpen,
    clientSecret,
    isFormValid,
    onPressPlacesPayBtn,
    placesListData,
    editPlaceData,
    setEditPlaceData,
    onPressEditPayBtn,
    copyLocationDetailsToBilling
  };
};
